const hours = {
	"hours-view": {
		title: "Uren controle",
	},
};

export default hours;
